<body>
  <!-- ========================= header start ========================= -->
  <header class="header">
    <div class="navbar-area">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <!-- Navegación -->
            <nav class="navbar navbar-expand-lg">
              <a class="navbar-brand" href="index.html">
                <img src="../../../assets/logosis.png" alt="Logo" />
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="toggler-icon"></span>
                <span class="toggler-icon"></span>
                <span class="toggler-icon"></span>
              </button>

              <div
                class="collapse navbar-collapse sub-menu-bar"
                id="navbarSupportedContent"
              >
                <div class="ms-auto">
                  <ul id="nav" class="navbar-nav ms-auto">
                    <li class="nav-item">
                      <a class="page-scroll active" href="#home">Inicio</a>
                    </li>
                    <li class="nav-item">
                      <a class="page-scroll" href="#about">Nosotros</a>
                    </li>
                    <li class="nav-item">
                      <a class="page-scroll" href="#features">Servicios</a>
                    </li>
                    <li class="nav-item">
                      <a class="page-scroll" href="#products">Productos</a>
                    </li>
                    <li class="nav-item">
                      <a class="page-scroll" href="#contact">Contacto</a>
                    </li>
                    <li class="nav-item">
                      <a class="d-flex d-lg-none" href="sisproteck-application">Aplicación</a>
                    </li>
                  </ul>
                  
                </div>
                <div class="">
                  <a href="sisproteck-application" class="main-btn d-none d-lg-flex btn-hover">Aplicación</a>
                </div>
              </div>

              
              <!-- navbar collapse -->
            </nav>
            <!-- navbar -->
          </div>
        </div>
        <!-- row -->
      </div>
      <!-- container -->
    </div>
    <!-- navbar area -->
  </header>
  <!-- ========================= header end ========================= -->

  <!-- ========================= hero-section start ========================= -->
  <section id="home" class="hero-section">
    <div class="hero-wrapper">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xxl-5 col-xl-6 col-lg-6 col-md-10">
            <div class="hero-content">
              <h1>¡Protege tu pasión por la carretera con estilo!</h1>
              <p>
                🔥¡Presentamos la Chaqueta de Protección para Motociclistas,
                diseñada exclusivamente para ti, amante de la adrenalina y la
                seguridad en dos ruedas!🔥
              </p>

              <a href="#0" class="main-btn btn-hover">Conócenos</a>
            </div>
          </div>
          <div class="col-xxl-6 col-xl-6 col-lg-6 offset-xxl-1">
            <div class="hero-image text-center text-lg-start d-none d-lg-flex">
              <img class="img-fluid rounded d-none d-md-flex" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ========================= about-section start ========================= -->
  <section id="about" class="about-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 order-last order-lg-first">
          <div class="about-image text-center text-lg-end">
            <img src="../../../assets/pro/15.png" alt="" />
          </div>
        </div>
        <div class="col-lg-6 col-md-10">
          <div class="about-content-wrapper">
            <div class="section-title">
              <h2 class="mb-20">
                Amamos hacer chaquetas para todos los gustos.
              </h2>
              <p class="mb-2">
                🛡️ Material de alta resistencia que proporciona protección
                contra impactos y abrasiones.
              </p>
              <p class="mb-2">
                🔒 Sistema de cierre ajustable que garantiza un ajuste cómodo y
                seguro.
              </p>
              <p class="mb-2">
                🌬️ Ventilación estratégica para mantenerte fresco en tus viajes
                más largos.
              </p>
              <p class="mb-2">
                📱 Bolsillos internos diseñados para dispositivos electrónicos y
                otros elementos esenciales.
              </p>
              <p class="mb-30">
                🌦️ Resistente al clima para mantenerte seco en cualquier
                condición.
              </p>
              <a href="https://api.whatsapp.com/send?phone=573214141506" class="main-btn btn-hover">Empecemos</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ========================= about-section end ========================= -->

  <!-- ========================= feature-section start ========================= -->
  <section id="features" class="feature-section">
    <div class="feature-wrapper">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11">
            <div class="section-title text-center mb-40">
              <h2>Nuestros Servicios <br class="d-block" /></h2>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-feature-wrapper">
              <div class="single-feature">
                <div class="feature-icon color-1">
                  <svg
                    fill="#e56935"
                    height="70px"
                    width="70px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <g>
                          <path
                            d="M19.799,358.708v36.537c0,10.345,8.387,18.732,18.732,18.732h38.075v-55.269H19.799z"
                          ></path>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M345.666,58.206h-3.167V18.732C342.499,8.387,334.113,0,323.768,0H188.232c-10.345,0-18.732,8.387-18.732,18.732v39.474 h-3.167c-80.014,0-146.534,64.79-146.534,146.534v116.505h56.807V194.563c0-10.345,8.387-18.732,18.732-18.732 s18.732,8.387,18.732,18.732c0,12.619,0.001,286.086,0.001,298.706c0,10.345,8.387,18.732,18.732,18.732h104.466V95.67h37.463V512 h104.466c10.345,0,18.732-8.387,18.732-18.732c0-12.93,0.001-286.223,0.001-298.706c0-10.345,8.387-18.732,18.732-18.732 s18.732,8.387,18.732,18.732v126.683h56.807V204.74C492.201,123,425.684,58.206,345.666,58.206z M305.036,58.206 c-11.903,0-89.463,0-98.072,0V37.463h98.072V58.206z"
                          ></path>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M435.394,358.708v55.269h38.075c10.345,0,18.732-8.387,18.732-18.732v-36.537H435.394z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="feature-content">
                  <h3 style="color: #f4623a">Chaquetas</h3>
                  <p>Creamos y Diseñamos Chaquetas Para Motociclistas.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-feature-wrapper">
              <div class="single-feature">
                <div class="feature-icon color-2">
                  <svg
                    fill="#e56935"
                    height="70"
                    width="70px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xml:space="preserve"
                    stroke="#e56935"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <g>
                          <path
                            d="M401.752,216.38c-19.692,0-35.712,16.02-35.712,35.712c0,19.688,16.02,35.704,35.712,35.704 c19.688,0,35.708-16.016,35.708-35.704C437.46,232.4,421.44,216.38,401.752,216.38z"
                          ></path>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path
                            d="M497.856,126H488v-9.408C488,94.168,475.548,82,453.116,82H436l0.064-28h-2.268h-16c-4.416,0-13.792,0-13.792,0v28H84 V67.872c0-4.42-3.584-8-8-8s-8,3.58-8,8V82h-5.28C40.288,82,16,94.168,16,116.592V223.66C16,246.088,40.288,270,62.72,270H60 v30.168c0,4.42-0.124,13.956-0.124,13.956L68,314v38.396c0,4.416,3.584,8,8,8s8-3.584,8-8V314h7.752c0,0,0.248-9.412,0.248-13.832 V270h9.116C123.548,270,136,246.088,136,223.66V214h168v164H25.96C14.932,378,0,381.06,0,392.088v55.916C0,458,0,458,9.96,458 h498.164c0,0-0.124-7.784-0.124-9.996v-55.916c0-11.032-3.116-14.088-14.144-14.088H488V214l12.516-0.32 C512,213.564,512,209.812,512,187.84v-47.544C512,129.268,508.884,126,497.856,126z M388,346h-24.064c0,0,0.064-7.792,0.064-9.996 l-0.064-5.94c0,0,7.48-0.064,9.688-0.064H388V346z M428,336.004c0,2.204,0,9.996,0,9.996h-24v-16h24V336.004z M401.752,304.128 c-28.696,0-52.044-23.344-52.044-52.04c0-28.7,23.348-52.048,52.044-52.048s52.04,23.348,52.04,52.048 C453.792,280.784,430.448,304.128,401.752,304.128z"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="feature-content">
                  <h3 style="color: #f4623a">Diseño Personalizado</h3>
                  <p>El Logo o Color Que Mas Te Guste.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-feature-wrapper">
              <div class="single-feature">
                <div class="feature-icon color-3">
                  <svg
                    xml:space="preserve"
                    viewBox="0 0 80 80"
                    y="0"
                    x="0"
                    xmlns="http://www.w3.org/2000/svg"
                    id="圖層_1"
                    version="1.1"
                    preserveAspectRatio="xMidYMid"
                    width="400"
                    height="400"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    style="
                      margin-top: 0px;
                      margin-right: 0px;
                      margin-bottom: 0px;
                      margin-left: 0px;
                      display: block;
                      shape-rendering: auto;
                      background-position-x: 0%;
                      background-position-y: 0%;
                      background-size: auto;
                      background-origin: padding-box;
                      background-clip: border-box;
                      background: scroll rgba(0, 0, 0, 0) none repeat;
                      width: 200px;
                      height: 200px;
                      animation: none;
                    "
                  >
                    <g
                      class="ldl-scale"
                      style="
                        transform-origin: 50px 50px;
                        transform: matrix(0.8, 0, 0, 0.8, 0, 0);
                        animation: none;
                      "
                    >
                      <g class="ldl-ani">
                        <g class="ldl-layer">
                          <g
                            class="ldl-ani"
                            style="
                              transform-origin: 50px 50px;
                              transform: matrix(1.01568, 0, 0, 1.01568, 0, 0);
                              animation-duration: 1s;
                              animation-timing-function: linear;
                              animation-delay: -0.625s;
                              animation-iteration-count: infinite;
                              animation-direction: normal;
                              animation-fill-mode: forwards;
                              animation-play-state: paused;
                              animation-name: animate;
                              animation-timeline: auto;
                              animation-range-start: normal;
                              animation-range-end: normal;
                              transform-box: view-box;
                              animation: none;
                            "
                          >
                            <path
                              fill="#333"
                              d="M37.4 18.3l-12-.1-.4 7.9c8.2 0 12.4-2.6 12.4-7.8z"
                              style="
                                stroke-width: 1px;
                                fill: rgb(229, 105, 53);
                                animation: none;
                              "
                            ></path>
                          </g>
                        </g>
                        <g class="ldl-layer">
                          <g
                            class="ldl-ani"
                            style="
                              transform-origin: 50px 50px;
                              transform: matrix(0.97254, 0, 0, 0.97254, 0, 0);
                              animation-duration: 1s;
                              animation-timing-function: linear;
                              animation-delay: -0.75s;
                              animation-iteration-count: infinite;
                              animation-direction: normal;
                              animation-fill-mode: forwards;
                              animation-play-state: paused;
                              animation-name: animate;
                              animation-timeline: auto;
                              animation-range-start: normal;
                              animation-range-end: normal;
                              transform-box: view-box;
                              animation: none;
                            "
                          >
                            <path
                              fill="#333"
                              d="M62.6 18.3c0 5.1 4.2 7.7 12.4 7.7l-.5-7.8-11.9.1z"
                              style="
                                stroke-width: 1px;
                                fill: rgb(229, 105, 53);
                                animation: none;
                              "
                            ></path>
                          </g>
                        </g>
                        <g class="ldl-layer">
                          <g
                            class="ldl-ani"
                            style="
                              transform-origin: 50px 50px;
                              transform: matrix(0.921517, 0, 0, 0.921517, 0, 0);
                              animation-duration: 1s;
                              animation-timing-function: linear;
                              animation-delay: -0.875s;
                              animation-iteration-count: infinite;
                              animation-direction: normal;
                              animation-fill-mode: forwards;
                              animation-play-state: paused;
                              animation-name: animate;
                              animation-timeline: auto;
                              animation-range-start: normal;
                              animation-range-end: normal;
                              transform-box: view-box;
                              animation: none;
                            "
                          >
                            <path
                              fill="#333"
                              d="M75.2 29H75c-13.4 0-15.4-6.7-15.4-10.7v-.1H40.4v.1c0 4-2 10.7-15.4 10.7h-.2l-3.7 63.2 17.3.3 8.1-54.9c.2-1.7 1.7-3 3.5-3s3.2 1.3 3.5 3l8.1 54.9 17.3-.3L75.2 29z"
                              style="
                                stroke-width: 1px;
                                fill: rgb(229, 105, 53);
                                animation: none;
                              "
                            ></path>
                          </g>
                        </g>
                        <g class="ldl-layer">
                          <g
                            class="ldl-ani"
                            style="
                              transform-origin: 50px 50px;
                              transform: matrix(0.91, 0, 0, 0.91, 0, 0);
                              animation-duration: 1s;
                              animation-timing-function: linear;
                              animation-delay: -1s;
                              animation-iteration-count: infinite;
                              animation-direction: normal;
                              animation-fill-mode: forwards;
                              animation-play-state: paused;
                              animation-name: animate;
                              animation-timeline: auto;
                              animation-range-start: normal;
                              animation-range-end: normal;
                              transform-box: view-box;
                              animation: none;
                            "
                          >
                            <path
                              d="M26.4 8.8l-.4 6.6h48l-.4-6.6z"
                              fill="#333"
                              style="
                                stroke-width: 1px;
                                fill: rgb(229, 105, 53);
                                animation: none;
                              "
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="feature-content">
                  <h3 style="color: #f4623a">Pantalones</h3>
                  <p>Creamos y Diseñamos Pantalones Para Motociclistas.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ========================= feature-section end ========================= -->

  <!-- ========================= products-section start ========================= -->
  <section id="products" class="testimonial-section">
    <div class="testimonial-wrapper">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="section-title text-center mb-10">
              <h2>Chaquetas & Buzos</h2>
            </div>
          </div>
        </div>
        <div class="testimonial-active-wrapper">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="single-feature-wrapper">
                <div class="single-feature">
                  <a
                    class="portfolio-box"
                    target="_blank"
                    href="assets/img/portfolio/fullsize/1.png"
                    title="Project Name"
                  >
                    <img
                      class="img-fluid"
                      target="_blank"
                      src="assets/img/portfolio/thumbnails/1.png"
                      alt="..."
                    />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="single-feature-wrapper">
                <div class="single-feature">
                  <a
                    class="portfolio-box"
                    target="_blank"
                    href="assets/img/portfolio/fullsize/2.png"
                    title="Project Name"
                  >
                    <img
                      class="img-fluid"
                      target="_blank"
                      src="assets/img/portfolio/thumbnails/2.png"
                      alt="..."
                    />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="single-feature-wrapper">
                <div class="single-feature">
                    <a
                    class="portfolio-box"
                    target="_blank"
                    href="assets/img/portfolio/fullsize/3.png"
                    title="Project Name"
                  >
                    <img
                      class="img-fluid"
                      target="_blank"
                      src="assets/img/portfolio/thumbnails/3.png"
                      alt="..."
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-10">
            <div class="row flex-row justify-content-center">
              <div class="col-lg-2 col-md-6" style="margin: 5px;">
                <div class="button1">
                  <a href="sisproteck-designs" class="main-btn btn-hover">Ver chaquetas</a>
                </div>
              </div>
              <br>
              <div class="col-lg-2 col-md-6" style="margin: 5px;">
                <div class="button2">
                  <a href="sisproteck-hoodies" class="main-btn btn-hover">Ver buzos</a>
                </div>
              </div>
              <br>
              <div class="col-lg-2 col-md-6" style="margin: 5px;">
                <div class="button2">
                  <a href="sisproteck-jackets" class="main-btn btn-hover">Ver Reflectivos</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ========================= products-section end ========================= -->


  <!-- ========================= contact-section start ========================= -->
  <section id="contact" class="pricing-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-10">
                <div class="section-title text-center">
                    <h2>Hablemos! <br class="d-block"></h2>
                    <p>¡No comprometas tu seguridad ni tu estilo! Contáctanos hoy mismo para obtener más información sobre cómo adquirir tu propia Chaqueta de Protección para Motociclistas.</p>
                </div>
            </div>
        </div>
        <div class="row align-items-center justify-content-center">
            <div class="col-lg-4 col-md-8 col-sm-10">
                <div class="single-pricing basic">
                    <div class="pricing-header">
                        <div class="feature-icon w-25">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#f4623a"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 7.00005L10.2 11.65C11.2667 12.45 12.7333 12.45 13.8 11.65L20 7" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <rect x="3" y="5" width="18" height="14" rx="2" stroke="" stroke-width="2" stroke-linecap="round"></rect> </g></svg>								
                        </div>
                        <h5 class="package-name">
                            <a href="mailto:sisproteckmotos@gmail.com">sisproteckmotos@gmail.com</a>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-10">
                <div class="single-pricing basic">
                    <div class="pricing-header">
                        <div class="feature-icon w-25">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15.5562 14.5477L15.1007 15.0272C15.1007 15.0272 14.0181 16.167 11.0631 13.0559C8.10812 9.94484 9.1907 8.80507 9.1907 8.80507L9.47752 8.50311C10.1841 7.75924 10.2507 6.56497 9.63424 5.6931L8.37326 3.90961C7.61028 2.8305 6.13596 2.68795 5.26145 3.60864L3.69185 5.26114C3.25823 5.71766 2.96765 6.30945 3.00289 6.96594C3.09304 8.64546 3.81071 12.259 7.81536 16.4752C12.0621 20.9462 16.0468 21.1239 17.6763 20.9631C18.1917 20.9122 18.6399 20.6343 19.0011 20.254L20.4217 18.7584C21.3806 17.7489 21.1102 16.0182 19.8833 15.312L17.9728 14.2123C17.1672 13.7486 16.1858 13.8848 15.5562 14.5477Z" fill="#f4623a"></path> <path d="M13.2595 1.87983C13.3257 1.47094 13.7122 1.19357 14.1211 1.25976C14.1464 1.26461 14.2279 1.27983 14.2705 1.28933C14.3559 1.30834 14.4749 1.33759 14.6233 1.38082C14.9201 1.46726 15.3347 1.60967 15.8323 1.8378C16.8286 2.29456 18.1544 3.09356 19.5302 4.46936C20.906 5.84516 21.705 7.17097 22.1617 8.16725C22.3899 8.66487 22.5323 9.07947 22.6187 9.37625C22.6619 9.52466 22.6912 9.64369 22.7102 9.72901C22.7197 9.77168 22.7267 9.80594 22.7315 9.83125L22.7373 9.86245C22.8034 10.2713 22.5286 10.6739 22.1197 10.7401C21.712 10.8061 21.3279 10.53 21.2601 10.1231C21.258 10.1121 21.2522 10.0828 21.2461 10.0551C21.2337 9.9997 21.2124 9.91188 21.1786 9.79572C21.1109 9.56339 20.9934 9.21806 20.7982 8.79238C20.4084 7.94207 19.7074 6.76789 18.4695 5.53002C17.2317 4.29216 16.0575 3.59117 15.2072 3.20134C14.7815 3.00618 14.4362 2.88865 14.2038 2.82097C14.0877 2.78714 13.9417 2.75363 13.8863 2.7413C13.4793 2.67347 13.1935 2.28755 13.2595 1.87983Z" fill="#f4623a"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.4857 5.3293C13.5995 4.93102 14.0146 4.7004 14.4129 4.81419L14.2069 5.53534C14.4129 4.81419 14.4129 4.81419 14.4129 4.81419L14.4144 4.81461L14.4159 4.81505L14.4192 4.81602L14.427 4.81834L14.4468 4.8245C14.4618 4.82932 14.4807 4.8356 14.5031 4.84357C14.548 4.85951 14.6074 4.88217 14.6802 4.91337C14.8259 4.97581 15.0249 5.07223 15.2695 5.21694C15.7589 5.50662 16.4271 5.9878 17.2121 6.77277C17.9971 7.55775 18.4782 8.22593 18.7679 8.7154C18.9126 8.95991 19.009 9.15897 19.0715 9.30466C19.1027 9.37746 19.1254 9.43682 19.1413 9.48173C19.1493 9.50418 19.1555 9.52301 19.1604 9.53809L19.1665 9.55788L19.1688 9.56563L19.1698 9.56896L19.1702 9.5705C19.1702 9.5705 19.1707 9.57194 18.4495 9.77798L19.1707 9.57194C19.2845 9.97021 19.0538 10.3853 18.6556 10.4991C18.2607 10.6119 17.8492 10.3862 17.7313 9.99413L17.7276 9.98335C17.7223 9.96832 17.7113 9.93874 17.6928 9.89554C17.6558 9.8092 17.5887 9.66797 17.4771 9.47938C17.2541 9.10264 16.8514 8.53339 16.1514 7.83343C15.4515 7.13348 14.8822 6.73078 14.5055 6.50781C14.3169 6.39619 14.1757 6.32909 14.0893 6.29209C14.0461 6.27358 14.0165 6.26254 14.0015 6.25721L13.9907 6.25352C13.5987 6.13564 13.3729 5.72419 13.4857 5.3293Z" fill="#f4623a"></path> </g></svg>								
                        </div>
                        <h5 class="package-name">
                            <a href="tel:+57 321 414 15 06">+57 321 414 15 06</a>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-10">
                <div class="single-pricing premium">
                    <div class="pricing-header">
                        <div class="feature-icon w-25">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3.50002 12C3.50002 7.30558 7.3056 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C10.3278 20.5 8.77127 20.0182 7.45798 19.1861C7.21357 19.0313 6.91408 18.9899 6.63684 19.0726L3.75769 19.9319L4.84173 17.3953C4.96986 17.0955 4.94379 16.7521 4.77187 16.4751C3.9657 15.176 3.50002 13.6439 3.50002 12ZM12 1.5C6.20103 1.5 1.50002 6.20101 1.50002 12C1.50002 13.8381 1.97316 15.5683 2.80465 17.0727L1.08047 21.107C0.928048 21.4637 0.99561 21.8763 1.25382 22.1657C1.51203 22.4552 1.91432 22.5692 2.28599 22.4582L6.78541 21.1155C8.32245 21.9965 10.1037 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM14.2925 14.1824L12.9783 15.1081C12.3628 14.7575 11.6823 14.2681 10.9997 13.5855C10.2901 12.8759 9.76402 12.1433 9.37612 11.4713L10.2113 10.7624C10.5697 10.4582 10.6678 9.94533 10.447 9.53028L9.38284 7.53028C9.23954 7.26097 8.98116 7.0718 8.68115 7.01654C8.38113 6.96129 8.07231 7.046 7.84247 7.24659L7.52696 7.52195C6.76823 8.18414 6.3195 9.2723 6.69141 10.3741C7.07698 11.5163 7.89983 13.314 9.58552 14.9997C11.3991 16.8133 13.2413 17.5275 14.3186 17.8049C15.1866 18.0283 16.008 17.7288 16.5868 17.2572L17.1783 16.7752C17.4313 16.5691 17.5678 16.2524 17.544 15.9269C17.5201 15.6014 17.3389 15.308 17.0585 15.1409L15.3802 14.1409C15.0412 13.939 14.6152 13.9552 14.2925 14.1824Z" fill="#f4623a"></path> </g></svg>								
                        </div>
                        <h5 class="package-name">
                            <a href="https://wa.link/bsxhjo">+57 321 414 15 06</a>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- ========================= contact-section end ========================= -->

<!-- ========================= cta-section start ========================= -->
<section id="cta" class="cta-section">
    <div class="container">
        <div class="cta-wrapper">
            <div class="row align-items-center">
                <div class="col-xl-8 col-lg-8">
                    <div class="cta-title section-title">
                        <h2>Escribenos  <br class="d-block">
                            como quieres tu chaqueta!</h2>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-4">
                    <div class="flex justify-content-end align-items-end">
                            <a href="https://api.whatsapp.com/send?phone=573214141506" class="main-btn btn-hover p-4">Personaliza tu chaqueta</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- ========================= cta-section end ========================= -->

<!-- ========================= footer start ========================= -->
<footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-10">
                <div class="footer-widget">
                    <div class="logo">
                        <a href="index.html"> <img src="./assets/logosis.png" alt="logo"> </a>
                    </div>
                    <p class="desc">Empresa colombiana, dedicada a la venta de Chaquetas de Protección para Motociclistas.
                         Amamos hacer chaquetas para todos los gustos.</p>
                </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6">
                <div class="footer-widget">
                    <h3>Acerca de</h3>
                    <ul class="links">
                        <li><a href="#about">Nosotros</a></li>
                        <li><a href="#features">Servicios</a></li>
                        <li><a href="#pricing">Contacto</a></li>
                        <li><a href="sisproteck-application">Aplicación</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-3 col-lg-2 col-md-6 col-sm-6">
                <div class="footer-widget">
                    <h3>Productos</h3>
                    <ul class="links">
                        <li><a href="sisproteck-designs">Chaquetas</a></li>
                        <li><a href="sisproteck-hoodies">Buzos</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="footer-widget">
                    <h3>Siguenos</h3>
                    <ul class="social-links">
                        <li><a href="#0"><svg viewBox="-5 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" width="30" height="30"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>facebook [#ffffff]</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" transform="translate(-385.000000, -7399.000000)" fill="#ffffff"> <g id="icons" transform="translate(56.000000, 160.000000)"> <path d="M335.821282,7259 L335.821282,7250 L338.553693,7250 L339,7246 L335.821282,7246 L335.821282,7244.052 C335.821282,7243.022 335.847593,7242 337.286884,7242 L338.744689,7242 L338.744689,7239.14 C338.744689,7239.097 337.492497,7239 336.225687,7239 C333.580004,7239 331.923407,7240.657 331.923407,7243.7 L331.923407,7246 L329,7246 L329,7250 L331.923407,7250 L331.923407,7259 L335.821282,7259 Z" id="facebook-[#ffffff]"> </path> </g> </g> </g> </g></svg></a>
                        <li><a href="#0"><svg  xmlns="http://www.w3.org/2000/svg"  width="40"  height="40"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-brand-instagram"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 8a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z" /><path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" /><path d="M16.5 7.5v.01" /></svg></a></li>
                        <li><a href="#0"><svg  xmlns="http://www.w3.org/2000/svg"  width="40"  height="40"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-brand-x"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 4l11.733 16h4.267l-11.733 -16z" /><path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" /></svg></a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="copyright">
            <p>Copyright © 2025 - Sisproteck Motos</p>
        </div>
    </div>
</footer>
<!-- ========================= footer end ========================= -->


<!-- ========================= scroll-top ========================= -->
<a (click)="scrollTo()" class="scroll-top btn-hover">
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="white" width="20" height="20"><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg>
</a>


  <!-- Button trigger modal -->
  <a
    id="modals"
    type="button"
    data-bs-toggle="modal"
    data-bs-target="#exampleModal"
  >
  </a>

  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Felices Fiestas</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <img
            style="width: 100%"
            height="50%"
            src="../../../assets/fiestas.jpeg"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</body>
